<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toccn" id="copy_1"><span href="#/ItalianLover_copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toccn" id="part_1"><a href="#/ItalianLover_part_1">PART I: Preproduction</a></p>
<p class="toccn" id="chap_1"><a href="#/ItalianLover_chap_1">The Bebop Club</a></p>
<p class="toccn" id="chap_2"><a href="#/ItalianLover_chap_2">First Reconnaissance</a></p>
<p class="toccn" id="chap_3"><a href="#/ItalianLover_chap_3">Questura</a></p>
<p class="toccn" id="chap_4"><span href="#/ItalianLover_chap_4" title="Link target outside of Sample">Pitch Meeting</span></p>
<p class="toccn" id="chap_5"><span href="#/ItalianLover_chap_5" title="Link target outside of Sample">Cancer</span></p>
<p class="toccn" id="chap_6"><span href="#/ItalianLover_chap_6" title="Link target outside of Sample">Miranda</span></p>
<p class="toccn" id="chap_7"><span href="#/ItalianLover_chap_7" title="Link target outside of Sample">Plot Points</span></p>
<p class="toccn" id="chap_8"><span href="#/ItalianLover_chap_8" title="Link target outside of Sample">Piazza Tasso</span></p>
<p class="toccn" id="chap_9"><span href="#/ItalianLover_chap_9" title="Link target outside of Sample">Audition</span></p>
<p class="toccn" id="chap_10"><span href="#/ItalianLover_chap_10" title="Link target outside of Sample">Second Reconnaissance</span></p>
<p class="toccn" id="chap_11"><span href="#/ItalianLover_chap_11" title="Link target outside of Sample">Midwestern Christmas</span></p>
<p class="toccn" id="part_2"><span href="#/ItalianLover_part_2" title="Link target outside of Sample">PART II: Production</span></p>
<p class="toccn" id="chap_12"><span href="#/ItalianLover_chap_12" title="Link target outside of Sample">Miranda Arrives</span></p>
<p class="toccn" id="chap_13"><span href="#/ItalianLover_chap_13" title="Link target outside of Sample">Anna Karenina</span></p>
<p class="toccn" id="chap_14"><span href="#/ItalianLover_chap_14" title="Link target outside of Sample">Protestant Cemetery</span></p>
<p class="toccn" id="chap_15"><span href="#/ItalianLover_chap_15" title="Link target outside of Sample">Rehearsal</span></p>
<p class="toccn" id="chap_16"><span href="#/ItalianLover_chap_16" title="Link target outside of Sample">Tribunale</span></p>
<p class="toccn" id="chap_17"><span href="#/ItalianLover_chap_17" title="Link target outside of Sample">La Maremmana</span></p>
<p class="toccn" id="chap_18"><span href="#/ItalianLover_chap_18" title="Link target outside of Sample">Hump Day</span></p>
<p class="toccn" id="chap_19"><span href="#/ItalianLover_chap_19" title="Link target outside of Sample">The Crane</span></p>
<p class="toccn" id="chap_20"><span href="#/ItalianLover_chap_20" title="Link target outside of Sample">Cheval Glass</span></p>
<p class="toccn" id="chap_21"><span href="#/ItalianLover_chap_21" title="Link target outside of Sample">Settignano</span></p>
<p class="toccn" id="chap_22"><span href="#/ItalianLover_chap_22" title="Link target outside of Sample">Our Town</span></p>
<p class="toccn" id="chap_23"><span href="#/ItalianLover_chap_23" title="Link target outside of Sample">Auction</span></p>
<p class="toccn" id="chap_24"><span href="#/ItalianLover_chap_24" title="Link target outside of Sample">Easter Week</span></p>
<p class="toccn" id="chap_25"><span href="#/ItalianLover_chap_25" title="Link target outside of Sample">Frisbee</span></p>
<p class="toccn" id="part_3"><span href="#/ItalianLover_part_3" title="Link target outside of Sample">PART III: Postproduction</span></p>
<p class="toccn" id="chap_26"><span href="#/ItalianLover_chap_26" title="Link target outside of Sample">What Would Margot Do?</span></p>
<p class="toccn" id="chap_27"><span href="#/ItalianLover_chap_27" title="Link target outside of Sample">Director’s Cut</span></p>
<p class="toccn" id="chap_28"><span href="#/ItalianLover_chap_28" title="Link target outside of Sample">The Get</span></p>
<p class="toccn" id="chap_29"><span href="#/ItalianLover_chap_29" title="Link target outside of Sample">Dognapping</span></p>
<p class="toccn" id="chap_30"><span href="#/ItalianLover_chap_30" title="Link target outside of Sample">The Italian Lover</span></p>
<p class="toccn" id="ackn_1"><span href="#/ItalianLover_ackn_1" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ItalianLover_toc.vue?1019a3d2